import { render } from "./PageLogin.vue?vue&type=template&id=7fc8462e"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"
script.render = render

export default script